import { Quote } from "lucide-react";

export const TestimonialCard = ({ testimonial }) => (
  <figure
    className="flex h-full flex-col rounded-2xl border border-dashed border-slate-300 bg-white p-6"
    data-testid="testimonial-card"
  >
    <Quote className="h-7 w-7 text-navy-200" aria-hidden="true" />
    <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-slate-500">
      “{testimonial.quote}”
    </blockquote>
    <figcaption className="mt-5 border-t border-slate-100 pt-4">
      <p className="text-sm font-semibold text-navy-900">{testimonial.name}</p>
      <p className="mt-0.5 text-xs text-slate-400">{testimonial.detail}</p>
    </figcaption>
  </figure>
);
